import { useEffect } from 'react';
import { WithAccountId } from '@mews-commander/types';
import { ModalBodyWrapper, ModalWrapper } from '@mews-commander/ui';
import { Disabled } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { hasReadOnlyPrivilegesForCustomerData } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import { initializeAccountBilling } from '../actions/billing';
import { BillingPageLoadingWrapper } from '../components/BillingPageLoadingWrapper';
import { CustomerDetailModalHeader } from '../../customerDetail/components/CustomerDetailModalHeader';
import { AccountBilling } from './AccountBilling';

export const AccountBillingContainer = ({ accountId }: WithAccountId) => {
    const dispatch = useCommanderThunkDispatch();
    const enterpriseId = useCurrentEnterpriseId();
    const disabled = useCommanderSelector(hasReadOnlyPrivilegesForCustomerData);

    useEffect(() => {
        dispatch(initializeAccountBilling({ accountId, scope: accountId }));
    }, [accountId, dispatch, enterpriseId]);

    const scope = accountId;

    return (
        <ModalWrapper>
            <CustomerDetailModalHeader accountId={accountId} activeTab={TextKey.Billing} />
            <ModalBodyWrapper>
                <BillingPageLoadingWrapper scope={scope}>
                    <Disabled condition={disabled}>
                        <AccountBilling accountId={accountId} enterpriseId={enterpriseId} scope={scope} />
                    </Disabled>
                </BillingPageLoadingWrapper>
            </ModalBodyWrapper>
        </ModalWrapper>
    );
};
